export const vinSearchTransactionAll = "VinSearchTransaction/All";
export const vinSearchReportAll = "VinSearchReport/All";
export const developerAreaAll = "DeveloperArea/All";
export const exportToExcelManager = "ExportToExcel/Manager";